"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deals = exports.Header = exports.Desktop = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

var _SuperLink = _interopRequireDefault(require("../../SuperLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Desktop = _styledComponents["default"].div(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  display: none;\n  ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  ", " {\n    display: block;\n  }\n"])), _slice.mediaQueries[0]);

exports.Desktop = Desktop;
var Header = (0, _styledComponents["default"])(_slice.Flex).attrs({
  as: 'nav',
  alignItems: 'center',
  flexDirection: 'row',
  px: 8,
  py: 5
})(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  margin: 0 auto;\n  max-width: 1500px;\n"], ["\n  margin: 0 auto;\n  max-width: 1500px;\n"])));
exports.Header = Header;
var Deals = (0, _styledComponents["default"])(_SuperLink["default"])(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  cursor: pointer;\n  color: ", ";\n  font-family: ", ";\n  font-size: 20px;\n  font-weight: bold;\n  text-transform: uppercase;\n\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  cursor: pointer;\n  color: ", ";\n  font-family: ", ";\n  font-size: 20px;\n  font-weight: bold;\n  text-transform: uppercase;\n\n  &:hover {\n    text-decoration: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.fonts.mrEaves;
});
exports.Deals = Deals;
var templateObject_1, templateObject_2, templateObject_3;